import { render, staticRenderFns } from "./PaymentNewTraffic.vue?vue&type=template&id=1e034938&scoped=true"
import script from "./PaymentNewTraffic.vue?vue&type=script&lang=ts"
export * from "./PaymentNewTraffic.vue?vue&type=script&lang=ts"
import style0 from "./PaymentNewTraffic.vue?vue&type=style&index=0&id=1e034938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e034938",
  null
  
)

export default component.exports